import * as yup from "yup";

export const SystemAccessSetupValidationSchema = yup.object().shape({
	accessLevel: yup.string().required("Access Level is required"),
	employeeId: yup.string().required("Employee is required"),
	firstName: yup.string().required("Name is required"),
	lastName: yup.string().required("Last Name is required"),
	status: yup.string().required("Status is required"),
	email: yup
		.string()
		// .trim()
		.required("Email is required")
		.email("Must be a valid email address")
		// .matches(/\.[A-Za-z]{2,}$/, "Must be a valid email address")
		.matches(/\.[A-Za-z]{2,}$/, {
			message: "Must be a valid email address",
			excludeEmptyString: true,
		}),
});
